module.exports = __webpack_public_path__ + "img/all_notifications_white.d1a7d2c4.svg";